import { getQueryStringParameterByName } from './apiHelpers';
import { VITE_USERS_API } from 'Constants/appEnvConstants';

export default function getBaseUrl() {
  return getQueryStringParameterByName('useMockApi')
    ? 'http://localhost:3009/'
   : VITE_USERS_API; // eslint-disable-line no-undef
}
